import { StatCompon } from './Statistics/MainStatistics';

export const App = () => {
  return (
    <div className="wrapper">
      <StatCompon />

      {/* <BoardCard
        imgURL="https://post.healthline.com/wp-content/uploads/2020/09/healthy-eating-ingredients-732x549-thumbnail.jpg"
        label="food"
        title="Delicious Food"
        text="Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestiae eius necessitatibus omnis asperiores, consequuntur ab aspernatur commodi
                    neque ad architecto, at aliquid temporibus, odit alias non error ipsa quo et"
        user={{
          avatar: 'https://cdn-icons-png.flaticon.com/512/147/147142.png',
          name: 'Jane Doe',
          time: '3 months ago',
        }}
      /> */}
    </div>
  );
};
